module.exports = __webpack_public_path__ + "img/checked.8150d533.svg";